class Modal {
    constructor(passedElement) {


    }

    init() {
        let self = this;

        const modal = document.getElementById('exampleModal');
        const openModalButton = document.getElementById('openModal');
        const closeModalButton = document.getElementById('closeModal');
        
        // Function to open modal
        function openModal() {
          modal.classList.add('show');
          modal.style.display = 'block';
          document.body.classList.add('modal-open');
          const backdrop = document.createElement('div');
          backdrop.className = 'modal-backdrop fade show';
          document.body.appendChild(backdrop);
        }
        
        // Function to close modal
        function closeModal() {
          modal.classList.remove('show');
          modal.style.display = 'none';
          document.body.classList.remove('modal-open');
          const backdrop = document.querySelector('.modal-backdrop');
          if (backdrop) {
            backdrop.remove();
          }
        }
        
        // Event listeners for opening/closing the modal
        openModalButton.addEventListener('click', openModal);
        closeModalButton.addEventListener('click', closeModal);
        
        // Close modal on outside click
        window.addEventListener('click', function(event) {
          if (event.target === modal) {
            closeModal();
          }
        });
    }


}

export default Modal;
